import { render, staticRenderFns } from "./RowCardItemCard.vue?vue&type=template&id=c8711224&scoped=true"
import script from "./RowCardItemCard.vue?vue&type=script&lang=js"
export * from "./RowCardItemCard.vue?vue&type=script&lang=js"
import style0 from "./RowCardItemCard.vue?vue&type=style&index=0&id=c8711224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8711224",
  null
  
)

export default component.exports